// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3e-U6","addWidgetButton":"Header_addWidgetButton__2UEDA","dashboardTabs":"Header_dashboardTabs__xxFzW","active":"Header_active__3Iswf"};